(function () {
  var root = document.querySelector('[data-lp-search]');
  if (!root) return;
  var input = root.querySelector('[data-lp-search-input]');
  var closeBtn = root.querySelector('[data-lp-search-close]');
  var backdrop = root.querySelector('[data-lp-search-backdrop]');
  var srch = root; // root IS the .lp-srch element
  var recentWrap = root.querySelector('[data-lp-recent-wrap]');
  var recentList = root.querySelector('[data-lp-recent]');
  var RECENT_KEY = 'lp:recent-searches';
  var recentMax = parseInt(root.getAttribute('data-recent-max'), 10) || 6;

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  }
  function saveRecent(term) {
    term = (term || '').trim();
    if (!term) return;
    var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    list = list.slice(0, recentMax);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function renderRecent() {
    if (!recentWrap || !recentList) return;
    var list = getRecent();
    if (!list.length) { recentWrap.hidden = true; return; }
    recentWrap.hidden = false;
    recentList.innerHTML = list.map(function (t) {
      var safe = t.replace(/[&<>"]/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; });
      return '<button class="lp-srch-recent-row" type="button" data-lp-term="' + safe + '">' +
        '<span style="display:inline-flex;color:var(--pierre)">' + iconSearch() + '</span>' +
        '<span>' + safe + '</span>' +
        '<span class="lp-srch-arr">' + iconArrow() + '</span></button>';
    }).join('');
  }
  function iconSearch() { return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'; }
  function iconArrow() { return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg>'; }

  var triggerEl = null;

  function open() {
    triggerEl = document.activeElement;
    srch.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    renderRecent();
    setTimeout(function () { input && input.focus(); }, 30);
  }
  function close() {
    srch.classList.remove('is-open', 'is-typing');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (input) input.value = '';
    if (triggerEl) { triggerEl.focus(); triggerEl = null; }
  }

  // Focus trap: keep Tab within the panel while the overlay is open.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !srch.classList.contains('is-open')) return;
    var panel = root.querySelector('[data-lp-search-panel]') || root;
    var candidates = Array.prototype.slice.call(
      panel.querySelectorAll('input, button, a[href], [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!candidates.length) return;
    var first = candidates[0];
    var last = candidates[candidates.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Intercept the vendor search icon(s) so the LP overlay opens instead of the vendor drawer.
  function bindTriggers() {
    var triggers = document.querySelectorAll('a[aria-controls="drawer-search-form"], .hdt-site-nav_search a, [data-lp-open-search]');
    triggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        open();
      }, true); // capture phase — beat the vendor drawer handler
    });
  }
  bindTriggers();

  closeBtn && closeBtn.addEventListener('click', close);
  backdrop && backdrop.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && srch.classList.contains('is-open')) close(); });

  // Popular / recent / pill clicks → fill input + (Task 4 will trigger search). For now, fill + save.
  root.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-lp-term]');
    if (pill) {
      var term = pill.getAttribute('data-lp-term');
      if (input) { input.value = term; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); }
    }
  });

  // Enter in input → go to /search?q= and save recent.
  input && input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = input.value.trim();
      if (q) { saveRecent(q); window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product'; }
    }
  });

  // expose helpers for Task 4
  root._lpSearch = { saveRecent: saveRecent, srch: srch };

  // --- Task 4: live results ---
  var resultsEl = root.querySelector('[data-lp-search-results]');
  var suggestUrl = root.getAttribute('data-lp-suggest-url') || '/search/suggest';
  var limit = parseInt(root.getAttribute('data-results-limit'), 10) || 6;
  var debounceT, ctrl;

  // XSS-safe escape (reuse pattern already in file)
  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Format raw COP decimal string → "$145.500"
  function formatPrice(raw) {
    var n = parseFloat(raw);
    if (isNaN(n)) return '';
    return '$ ' + Math.round(n).toLocaleString('es-CO');
  }

  function renderResults(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = (r.products || []).slice(0, limit);
    var collections = (r.collections || []).slice(0, 4);
    var queries = (r.queries || []).slice(0, 5);

    var prodHtml;
    if (products.length) {
      prodHtml = products.map(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var priceOrBadge = p.available === false
          ? '<span class="pill-sm" style="background:var(--pierre); color:var(--lait);">Agotado</span>'
          : '<span class="p">' + esc(formatPrice(p.price)) + '</span>';
        return '<a class="lp-srch-prod" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
          '<span><span class="v">' + esc(p.vendor || '') + '</span><br><span class="t">' + esc(p.title) + '</span></span>' +
          priceOrBadge + '</a>';
      }).join('');
    } else {
      prodHtml = '<div class="lp-srch-empty">' + esc(root.getAttribute('data-no-results') || '') + '</div>';
    }

    var sideHtml = '';
    if (collections.length) {
      sideHtml += '<div class="kicker lp-srch-lbl">Colecciones</div>' +
        collections.map(function (c) {
          return '<a class="lp-srch-prod" href="' + esc(c.url) + '"><span></span><span class="t">' + esc(c.title) + '</span><span></span></a>';
        }).join('');
    }
    if (queries.length) {
      sideHtml += '<div class="kicker lp-srch-lbl" style="margin-top:18px">Sugerencias</div>' +
        '<div class="lp-srch-pills">' +
        queries.map(function (s) {
          return '<button class="lp-srch-pill" type="button" data-lp-term="' + esc(s.text) + '">' + esc(s.text) + '</button>';
        }).join('') + '</div>';
    }
    sideHtml += '<a class="lp-srch-ver" style="margin-top:20px;margin-left:0" href="/search?q=' + encodeURIComponent(q) + '&type=product" data-lp-ver-todos>Ver todos los resultados ' + iconArrow() + '</a>';

    resultsEl.innerHTML =
      '<div><div class="kicker lp-srch-lbl">Productos</div>' + prodHtml + '</div>' +
      '<div>' + sideHtml + '</div>';
  }

  function doSearch(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var url = suggestUrl + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=' + limit +
      '&resources[options][unavailable_products]=show' +
      '&resources[options][fields]=title,vendor,product_type,variants.title';
    fetch(url, { signal: ctrl.signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { renderResults(j, q); })
      .catch(function (e) {
        if (e.name !== 'AbortError') {
          resultsEl.innerHTML = '<div class="lp-srch-empty">' + esc(root.getAttribute('data-no-results') || '') + '</div>';
        }
      });
  }

  input && input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q.length < 2) {
      srch.classList.remove('is-typing');
      clearTimeout(debounceT);
      if (ctrl) { ctrl.abort(); ctrl = null; }
      return;
    }
    srch.classList.add('is-typing');
    clearTimeout(debounceT);
    debounceT = setTimeout(function () { doSearch(q); }, 250);
  });

  // Clicking a product/collection link saves the recent term and (for "Ver todos") also saves.
  resultsEl && resultsEl.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (link) { saveRecent(input.value.trim()); }
  });
})();
